
import { configureStore } from '@reduxjs/toolkit';
import appSlice from './AppReducer';

export const store = configureStore({
  reducer: {
    app: appSlice,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({serializableCheck: false}),
});
export type AppDispatch = typeof store.dispatch;
export type IApplicationState = ReturnType<typeof store.getState>